var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363,
    height: 348,
    fill: "none",
    viewBox: "0 0 363 348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12275_2812)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12275_2812)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 174,
    r: 214,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12275_2812)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.999,
    cy: 174,
    r: 169.304,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12275_2812)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.999,
    cy: 174,
    r: 123.253,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_12275_2812)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.88,
    cy: 174.88,
    r: 77.88,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12275_2812)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6287B1",
    d: "M215.431 165.252C215.431 163.744 216.658 162.517 218.165 162.517H219.112L218.826 161.724C218.666 161.278 218.245 161 217.797 161C217.673 161 217.546 161.021 217.423 161.066L207.861 164.547C207.292 164.754 207 165.383 207.208 165.951L207.713 167.33H215.431V165.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6287B1",
    d: "M218.164 164.158C217.56 164.158 217.07 164.648 217.07 165.252V167.33H226.641V165.252C226.641 164.648 226.151 164.158 225.547 164.158H218.164ZM229.539 183.107H225.711C223.449 183.107 221.609 181.267 221.609 179.006C221.609 176.744 223.449 174.904 225.711 174.904H229.539V171.158C229.539 169.95 228.56 168.97 227.352 168.97H206.188C204.979 168.97 204 169.95 204 171.158V186.813C204 188.021 204.979 189 206.188 189H227.352C228.56 189 229.539 188.021 229.539 186.813V183.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6287B1",
    d: "M231.18 176.545H225.711C224.354 176.545 223.25 177.649 223.25 179.006C223.25 180.363 224.354 181.467 225.711 181.467H231.18C231.632 181.467 232 181.099 232 180.646V177.365C232 176.913 231.632 176.545 231.18 176.545ZM225.711 179.826C225.258 179.826 224.891 179.459 224.891 179.006C224.891 178.553 225.258 178.185 225.711 178.185C226.164 178.185 226.531 178.553 226.531 179.006C226.531 179.459 226.164 179.826 225.711 179.826Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12275_2812",
    width: 440,
    height: 440,
    x: -6,
    y: -43,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72452 0 0 0 0 0.730978 0 0 0 0 0.737435 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_12275_2812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12275_2812",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12275_2812",
    width: 350.609,
    height: 350.608,
    x: 38.695,
    y: 1.696,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72452 0 0 0 0 0.730978 0 0 0 0 0.737435 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_12275_2812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12275_2812",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12275_2812",
    width: 258.508,
    height: 258.506,
    x: 84.746,
    y: 47.747,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72452 0 0 0 0 0.730978 0 0 0 0 0.737435 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_12275_2812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12275_2812",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_12275_2812",
    width: 167.758,
    height: 167.76,
    x: 131,
    y: 94,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72452 0 0 0 0 0.730978 0 0 0 0 0.737435 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_12275_2812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12275_2812",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12275_2812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 348,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12275_2812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff",
    transform: "translate(204 161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e412a90bc989675f4874e875f0d09dac.svg";
export { ForwardRef as ReactComponent };